"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import axios from "axios"
import { API_URL } from "../config"
import { useLanguage } from "../context/LanguageContext"
import { useNotification } from "../context/NotificationContext"
import "./ForgotPassword.css"

const ForgotPassword = () => {
  const { t, direction } = useLanguage()
  const { showNotification } = useNotification()
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [emailSent, setEmailSent] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!email) {
      showNotification(t("Please enter your email address"), "error")
      return
    }

    try {
      setLoading(true)

      const res = await axios.post(`${API_URL}/api/auth/forgot-password`, { email })

      setEmailSent(true)
      showNotification(t("Password reset instructions sent to your email"), "success")
    } catch (err) {
      console.error(err)
      const errorMsg = err.response?.data?.msg || "An error occurred"
      showNotification(t(errorMsg), "error")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="forgot-password-container" dir={direction}>
      <div className="forgot-password-card">
        <div className="card-header">
          <h1>{t("Forgot Password")}</h1>
          <p>{t("Enter your email to receive password reset instructions")}</p>
        </div>

        {!emailSent ? (
          <form onSubmit={handleSubmit} className="forgot-password-form">
            <div className="form-group">
              <label htmlFor="email">{t("Email Address")}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("Enter your email")}
                required
              />
            </div>

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? t("Sending...") : t("Send Reset Link")}
            </button>

            <div className="form-links">
              <Link to="/login" className="back-to-login">
                <i className="fas fa-arrow-left"></i> {t("Back to Login")}
              </Link>
            </div>
          </form>
        ) : (
          <div className="email-sent-message">
            <div className="email-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h2>{t("Email Sent!")}</h2>
            <p>
              {t("We've sent password reset instructions to")} <strong>{email}</strong>.{" "}
              {t("Please check your inbox and follow the instructions.")}
            </p>
            <p className="email-note">
              {t("If you don't see the email, check your spam folder or")}
              <button className="resend-button" onClick={handleSubmit} disabled={loading}>
                {loading ? t("Sending...") : t("resend the email")}
              </button>
              .
            </p>
            <Link to="/login" className="back-button">
              {t("Back to Login")}
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default ForgotPassword
